export default __webpack_public_path__ + "static/media/diba-tracer-study.319ea611.png";